module.exports = "/images/scheduling_icon_white.svg?f5401ff9230f7ddcf92954577938730c";